import { usePermissions } from '@/hooks/usePermissions';
import Dashboard from '@/pages/Dashboard';
import CallCenterDashboard from '@/pages/callcenter/CallCenterDashboard';

/**
 * Smart dashboard that renders the appropriate dashboard
 * based on the user's role (CRM vs Call Center).
 */
export default function SmartDashboard() {
  const { isCallCenter } = usePermissions();

  if (isCallCenter) {
    return <CallCenterDashboard />;
  }

  return <Dashboard />;
}
